/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChangeUserPasswordBody
 */
export interface ChangeUserPasswordBody {
    /**
     * 
     * @type {string}
     * @memberof ChangeUserPasswordBody
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeUserPasswordBody
     */
    confirmPassword: string;
}

/**
 * Check if a given object implements the ChangeUserPasswordBody interface.
 */
export function instanceOfChangeUserPasswordBody(value: object): value is ChangeUserPasswordBody {
    if (!('password' in value) || value['password'] === undefined) return false;
    if (!('confirmPassword' in value) || value['confirmPassword'] === undefined) return false;
    return true;
}

export function ChangeUserPasswordBodyFromJSON(json: any): ChangeUserPasswordBody {
    return ChangeUserPasswordBodyFromJSONTyped(json, false);
}

export function ChangeUserPasswordBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangeUserPasswordBody {
    if (json == null) {
        return json;
    }
    return {
        
        'password': json['password'],
        'confirmPassword': json['confirmPassword'],
    };
}

export function ChangeUserPasswordBodyToJSON(json: any): ChangeUserPasswordBody {
    return ChangeUserPasswordBodyToJSONTyped(json, false);
}

export function ChangeUserPasswordBodyToJSONTyped(value?: ChangeUserPasswordBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'password': value['password'],
        'confirmPassword': value['confirmPassword'],
    };
}

